require("./bootstrap");
require("./jquery");
require("./foundation");
import { loadModules } from "esri-loader";
import "magnific-popup";
import "easy-autocomplete";
import "hotkeys-js";

$(document).foundation();

loadModules([
    "esri/Map",
    "esri/views/MapView",
    "esri/layers/KMLLayer",
    "esri/widgets/BasemapToggle",
    "esri/layers/GraphicsLayer",
    "esri/Graphic",
    "esri/PopupTemplate",
    "esri/layers/GeoJSONLayer",
    "esri/layers/FeatureLayer",
    "esri/widgets/Home",
    "esri/widgets/Legend",
    "esri/widgets/Expand",
    "esri/widgets/Locate",
])
    .then(
        ([
            Map,
            MapView,
            KMLLayer,
            BasemapToggle,
            GraphicsLayer,
            Graphic,
            PopupTemplate,
            GeoJSONLayer,
            FeatureLayer,
            Home,
            Legend,
            Expand,
            Locate,
        ]) => {
            let lng = "115.66281839872";
            let lat = "-2.1173443692105";

            var url = window.config.domain;
            var api = "/api/v1";
            var apiPlace = url + api + "/place";
            var apiProblem = url + api + "/problem";
            const infoDiv = document.getElementById("infoDiv");
            var hash = window.location.hash;
            var segments = hash.split("-");

            var renderer = {
                type: "unique-value", // autocasts as new UniqueValueRenderer()
                field: "category",
                defaultSymbol: {
                    type: "simple-marker",
                    size: 9,
                    color: "orange",
                },
                defaultLabel: "Kategori Lainnya",
                legendOptions: { title: "Kategori" },
                uniqueValueInfos: window.config.uniqueValueInfos,
            };

            var problemsLayer = new GeoJSONLayer({
                title: "Permasalahan Kawasan",
                outFields: ["*"],
                url: apiProblem,
                renderer: renderer,
                popupTemplate: {
                    title: "{title}",
                    actions: [
                        {
                            id: "goto-place",
                            image: "/front-assets/images/map-o.png",
                            // title: "{place}"
                            title: "Kawasan",
                        },
                    ],
                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                {
                                    fieldName: "placeId",
                                    visible: false,
                                },
                                {
                                    fieldName: "place",
                                    label: "Kawasan",
                                    visible: true,
                                },
                                {
                                    fieldName: "categoryName",
                                    label: "Kategori",
                                    visible: true,
                                },
                                {
                                    fieldName: "content",
                                    label: "Description",
                                    visible: true,
                                },
                            ],
                        },
                    ],
                },
            });

            problemsLayer
                .when()
                .then(function() {
                    view.whenLayerView(problemsLayer).then(function(layerView) {
                        const filterSelect = document.getElementById("filter");
                        // filters the problemsLayer using a definitionExpression
                        // based on a category selected by the user
                        filterSelect.addEventListener("change", function(
                            event
                        ) {
                            const newValue = event.target.value;

                            const whereClause = newValue
                                ? "category = '" + newValue + "'"
                                : null;

                            layerView.filter = {
                                where: whereClause,
                            };

                            // close popup for former cluster that no longer displays
                            view.popup.close();
                        });
                    });
                })
                .catch(function(error) {
                    console.error(error);
                });

            var map = new Map({
                basemap: "hybrid",
                layers: [problemsLayer],
            });

            var view = new MapView({
                container: "viewDiv",
                map: map,
                center: [lng, lat],
                zoom: 6,
            });

            var toggle = new BasemapToggle({
                view: view,
                nextBasemap: "streets",
            });

            var homeWidget = new Home({
                view: view,
            });

            view.ui.add(homeWidget, "top-right");

            view.ui.move(["zoom"], "top-right");

            const legend = new Expand({
                content: new Legend({
                    view: view,
                    container: "legendDiv",
                    style: "card",
                }),
                view: view,
                content: infoDiv,
                expanded: false,
            });

            const locate = new Locate({
                                view: view,
                                useHeadingEnabled: false,
                                goToOverride: function(view, options) {
                                    options.target.scale = 1500;
                                    return view.goTo(options.target);
                                }
                            });

            view.ui.add(locate, "top-right");
            view.ui.add(legend, "top-right");
            view.ui.add(toggle, "bottom-right");

            view.when(function() {
                var popup = view.popup;

                // Watch for when features are selected
                view.popup.watch("selectedFeature", function(graphic) {
                    if (graphic) {
                        var graphicTemplate = graphic.getEffectivePopupTemplate();
                        // console.info(graphicTemplate.actions.items);
                    }
                });

                /*
                popup.viewModel.on("trigger-action", function(event) {
                    if (event.action.id === "goto-place") {
                        var attributes = popup.viewModel.selectedFeature.attributes;

                        let dataPlace = loadPlace(attributes.placeId);

                        dataPlace.then(place => {
                            $('#modalSearch').foundation('close');
                        }).catch(error => {
                            console.info(error);
                            $('#modalSearch').foundation('close');
                        });

                    }
                });
            */
            });

            view.popup.on("trigger-action", function(event) {
                if (event.action.id === "goto-place") {
                    $(".loader").addClass("active");

                    let placeId = view.popup.selectedFeature.attributes.placeId;

                    let dataPlace = loadPlace(placeId);

                    dataPlace
                        .then((place) => {
                            $("#modalSearch").foundation("close");
                        })
                        .catch((error) => {
                            console.info(error);
                            $("#modalSearch").foundation("close");
                        });
                }
            });

            /* search auto complete */

            var optionsSearch = {
                url: function(phrase) {
                    var searchUrl = apiPlace + "?title=" + phrase;
                    return searchUrl;
                },
                listLocation: "data",
                getValue: "title",
                requestDelay: 300,
                list: {
                    onChooseEvent: function() {
                        $(".loader").addClass("active");

                        var data = $("#searchKawasan").getSelectedItemData();
                        let dataPlace = loadPlace(data.id);

                        dataPlace
                            .then((place) => {
                                $("#modalSearch").foundation("close");
                            })
                            .catch((error) => {
                                console.info(error);
                                $("#modalSearch").foundation("close");
                            });
                    },
                },
            };

            $("#searchKawasan").easyAutocomplete(optionsSearch);

            $("#detail-place").on("click", ".gallery-item", function(e) {
                e.preventDefault();
                $('.gallery').magnificPopup({
                    delegate: '.gallery-item',
                    type: 'image',
                    gallery: {
                        enabled: true
                    },
                });
            });

            $("#detail-place").on("click", ".gallery-item-lahan", function(e) {
                e.preventDefault();
                $('.gallery-lahan').magnificPopup({
                    delegate: '.gallery-item-lahan',
                    type: 'image',
                    gallery: {
                        enabled: true
                    },
                });
            });

            $("#detail-place").on("click", ".gall-prob-item", function(e) {
                e.preventDefault();
                $('.gall-prob').magnificPopup({
                    delegate: '.gall-prob-item',
                    type: 'image',
                    gallery: {
                        enabled: true
                    },
                });
            });


            $("#detail-place").on("click", ".pan", function(e) {
                e.preventDefault();
                view.center = [-99.94867549215655, 20.55088183550196];
                view.zoom = 5;
                $("#placeProblem").show();
            });
            $("#detail-place").on("click", "#btnHide-placeProblem", function(e){
                e.preventDefault();
                $("#placeProblem").hide();
            });

            $("#detail-place").on("click", ".tab-toggle", function(e) {
                e.preventDefault();

                let target = $(this).attr("href");

                $("#place-wrapper").addClass("active");

                $(".tab-toggle").removeClass("active");
                $(this).addClass("active");

                $(".tab-content").removeClass("active");
                $(target).addClass("active");
            });

            $("#detail-place").on("click", ".tab-close", function(e) {
                $("#place-wrapper").removeClass("active");
            });

            $("#detail-place").on("click", ".content-tab", function(e) {
                e.preventDefault();
                var that = $(this);
                var target = that.attr("href");

                $(".content-tab")
                    .parent()
                    .removeClass("is-active");
                $(".content-tab").attr("aria-selected", false);
                that.parent().addClass("is-active");
                that.attr("aria-selected", true);

                $(".tabs-panel").removeClass("is-active");
                $(target).addClass("is-active");
            });

            $("#modalSearch").on("open.zf.reveal", function() {
                $(this)
                    .find("#searchKawasan")
                    .focus();
            });

            $(document).on("click", "#tryMe", function(e) {
                e.preventDefault();
                const container = $("#detailContainer");

                $(this)
                    .find(".fas")
                    .toggleClass("fa-chevron-right fa-chevron-left");
                container.toggleClass("panel-expanded");
            });

            $("#btnShowHide").on("click", function() {
                $(this)
                    .find(".fas")
                    .toggleClass("fa-chevron-right fa-chevron-left");
            });

            // get current position

            var currentLocation = async function(id) {

            }

            // load detail place data

            var loadPlace = async function(id) {
                try {
                    view.popup.close();

                    let urlPlace = apiPlace + "/" + id;
                    let dataPlace = loadData(urlPlace);

                    dataPlace
                        .then((place) => {
                            if (place.data.id !== undefined) {
                                viewData(place.data);

                                window.location.hash = `${place.data.slug}-${place.data.id}`;
                            } else {
                                alert("Kawasan tidak ditemukan");

                                $(".loader").removeClass("active");
                            }
                        })
                        .catch((error) => {
                            console.info(error);
                        });
                } catch (error) {
                    console.error(error);
                }
            };

            // generate detail place

            var viewData = async function(result) {
                try {
                    let data = result;
                    let html = await loadTemplate(data);
                    let area = data.area;
                    area = area.replace(
                        "http://monikasiri.test",
                        "https://www.monikasiri.com"
                    );

                    // map.removeAll();

                    var kml = new KMLLayer({
                        url: area,
                        popupEnabled: false,
                        popupTemplate: false,
                    });

                    map.add(kml, 2);

                    view.center = [data.longitude, data.lattitude];
                    view.zoom = 13;

                    kml.when(
                        function() {
                            $(".loader").removeClass("active");
                        },
                        function(err) {
                            alert("Data KML Tidak Ditemukan");

                            $(".loader").removeClass("active");
                        }
                    );

                    $("#detail-place").empty();

                    $("<div/>", {
                        id: "place-wrapper",
                        class: "",
                        html: html,
                    }).appendTo("#detail-place");

                    $('#tryMe').trigger('click');

                } catch (error) {
                    console.error(error);
                }
            };

            // generate detail place template

            var loadTemplate = function(data) {

                let imgCover = '';

                if(data.gallery.length > 0) {
                    imgCover = `<picture id="place-imgCover" class="place-cover"><img class="place-cover-img" src="${data.gallery[0].image550}"></picture>`;
                }

                let heading = `<div class="place-header padding-1 margin-bottom-1">
                                <div class="h5 font-bold">${data.title}</div>
                                <div>
                                    <a href="${data.streamPdf}" target="_blank" class="button hollow radius small padding-hf margin-bottom-0 font-bold"><i class="fas fa-file-pdf"></i> Download</a>
                                    <a href="${data.streamReport}" class="button hollow radius small padding-hf margin-bottom-0 font-bold"><i class="fas fa-file-pdf"></i> Report</a>
                                </div>
                            </div>`;

                const tabs = `<ul class="tabs-nav flex-container align-justify" data-tabs id="tabs-detail-place">
                                <li class="tabs-title text-center is-active">
                                    <a class="content-tab" href="#panel1" aria-selected="true">
                                        <span class="display-block icon-place"><i class="fas fa-info"></i></span>
                                        <span class="display-block icon-text">Informasi</span>
                                    </a>
                                </li>
                                <li class="tabs-title text-center">
                                    <a class="content-tab" href="#panel2" aria-selected="false">
                                        <span class="display-block icon-place"><i class="fas fa-comment-dots fa-flip-horizontal"></i></span>
                                        <span class="display-block icon-text">Kesimpulan</span>
                                    </a>
                                </li>
                                <li class="tabs-title text-center">
                                    <a class="content-tab" href="#panel3" aria-selected="false">
                                        <span class="display-block icon-place"><i class="fas fa-image"></i></span>
                                        <span class="display-block icon-text">Gallery</span>
                                    </a>
                                </li>
                                <li class="tabs-title text-center">
                                    <a class="content-tab" href="#panel4" aria-selected="false">
                                        <span class="display-block icon-place"><i class="fas fa-map-marked-alt"></i></span>
                                        <span class="display-block icon-text">Peta Area</span>
                                    </a>
                                </li>
                                <!--
                                <li class="tabs-title text-center">
                                    <a class="content-tab" href="#panel5" aria-selected="false">
                                        <span class="display-block icon-place"><i class="fas fa-list-ul"></i></span>
                                        <span class="display-block icon-text">Permasalahan</span>
                                    </a>
                                </li>
                                -->
                            </ul>`;

                let listMasalah = `<div class="tabs-panel" id="panel5">
                                    <ul class="vertical menu problem-cat-menu">
                                        <li class="problem-cat-kebakaran">
                                            <a class="pan padding-horizontal-0" href="#">
                                                <div class="flex-container align-middle">
                                                    <picture class="problem-cat-icon radius flex-container align-middle align-center margin-right-hf">
                                                        <i class="las la-fire-alt la-2x"></i>
                                                    </picture>
                                                    <div class="flex-child-auto">
                                                        <small class="problem-cat-title display-block font-bold">Kebakaran Hutan</small>
                                                        <div class="problem-cat-desc">Judul masalah lorem ipsum ... </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="problem-cat-perambahan">
                                            <a class="pan padding-horizontal-0" href="#">
                                                <div class="flex-container align-middle">
                                                    <picture class="problem-cat-icon radius flex-container align-middle align-center margin-right-hf">
                                                        <i class="las la-map-marked la-2x"></i>
                                                    </picture>
                                                    <div class="flex-child-auto">
                                                        <small class="problem-cat-title display-block font-bold">Perambahan Lahan</small>
                                                        <div class="problem-cat-desc">When an unknown printer took a ... </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="problem-cat-adat">
                                            <a class="pan padding-horizontal-0" href="#">
                                                <div class="flex-container align-middle">
                                                    <picture class="problem-cat-icon radius flex-container align-middle align-center margin-right-hf">
                                                        <i class="las la-drafting-compass la-2x"></i>
                                                    </picture>
                                                    <div class="flex-child-auto">
                                                        <small class="problem-cat-title display-block font-bold">Hutan Adat</small>
                                                        <div class="problem-cat-desc">When an unknown printer took a ... </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>`;

                let peta = `<div class="tabs-panel" id="panel4">`;
                let html, gallery, call, info, kesimpulan;
                let belumTersedia = "<p>Data belum tersedia</p>";
                var gallery_item = [];

                call = "<p><b><em>Call Center: +62 8211778912</em></b></p>";

                $.each(data.gallery, function(key, value) {
                    gallery_item.push(
                        '<div class="gallery-item" data-mfp-src="' +
                            value.image +
                            '"><img src="' +
                            value.image250 +
                            '"></div>'
                    );
                });

                if (null !== data.content) {
                    info = `<div class="tabs-panel is-active" id="panel1">${data.content} ${call}</div>`;
                }

                if (null !== data.recommendation) {
                    kesimpulan = `<div class="tabs-panel" id="panel2">
                                <div class="content mb30">
                                  <p><label><b>Status:</b></label>${data.statusKesimpulan} (${data.value}%)</p>
                                  <div class="mt20"><label><b>Rekomendasi:</b></label>${data.recommendation}</div>
                                </div>
                              </div>`;
                } else {
                    kesimpulan = `<div class="tabs-panel" id="panel2">${belumTersedia}</div>`;
                }

                if (gallery_item.length > 0) {
                    gallery = `<div class="tabs-panel" id="panel3">
                              <p>Gallery.</p>
                              <div class="gallery">
                                ${gallery_item.join("")}
                              </div>
                          </div>`;
                } else {
                    gallery = `<div class="tabs-panel" id="panel3">
                              <p>Gallery.</p>
                              ${belumTersedia}
                          </div>`;
                }

                if (null !== data.peta_penutupan) {
                    peta += `<h5>Peta Zona/Blok</h5><div class="gallery-lahan"><div data-mfp-src="${data.peta_penutupan} " class="gallery-item-lahan"><img src="${data.peta_penutupan}"></div></div>`;
                } else {
                    peta += `<h5>Peta Zona/Blok</h5>${belumTersedia}`;
                }

                if (null !== data.peta_pembukaan) {
                    peta += `<h5>Peta Open Area</h5><div class="gallery-lahan"><div data-mfp-src="${data.peta_pembukaan}" class="gallery-item-lahan"><img src="${data.peta_pembukaan}"></div></div></div>`;
                } else {
                    peta += `<h5>Peta Open Area</h5>${belumTersedia}</div>`;
                }

                html = `<div id="detailContainer">
                            <div class="place-content">
                                ${imgCover}
                                ${heading}
                                <div class="padding-horizontal-1 margin-bottom-hf">
                                    ${tabs}
                                </div>
                                <div class="tabs-content tabs-content-place" data-tabs-content="tabs-detail-place" id="place-tabsContent">
                                    ${info}
                                    ${kesimpulan}
                                    ${gallery}
                                    ${peta}
                                    ${listMasalah}
                                </div>
                                <div id="placeProblem" class="place-wrapper-problem">
                                    <div class="place-header flex-container align-middle padding-hf hover-pointer" id="btnHide-placeProblem">
                                        <div class="place-header-left margin-right-hf padding-hf font-small text-muted">
                                            <i class="fas fa-arrow-left fa-lg"></i>
                                        </div>
                                        <div class="place-header-center font-small">
                                            <div class="font-bold">${data.title}</div>
                                        </div>
                                    </div>
                                    <div class="padding-1 place-problem-content">
                                        <div class="problem-cat-kebakaran font-small">
                                            <span class="problem-cat-icon problem-cat-icon-small display-inline-block radius"><i class="las la-fire-alt"></i></span>
                                            <span class="problem-cat-title">Kebakaran Hutan</span>
                                        </div>
                                        <h5 class="font-bold">Judul Masalah</h5>
                                        <div class="font-small flex-container margin-bottom-1">
                                            <div class="margin-right-hf"><span class="text-muted"><i class="fas fa-user-edit"></i></span> Iskandar Siswanto</div>
                                            <div class="text-muted"><i class="far fa-calendar-alt"></i> <time datetime="2017-02-14">January 17, 2021</time></div>
                                        </div>
                                        <div class="padding-bottom-1">
                                            <p>Deskripsi masalah lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English</p>
                                        </div>
                                        <h6 class="font-small font-bold text-muted">Gallery</h6>
                                        <div class="gall-prob">
                                            <div class="gall-prob-item" data-mfp-src="https://www.thersa.org/globalassets/images/arc/ffcc/ni_600400.jpg">
                                                <img src="https://www.thersa.org/globalassets/images/arc/ffcc/ni_600400.jpg">
                                            </div>
                                            <div class="gall-prob-item" data-mfp-src="https://www.thersa.org/globalassets/images/arc/ffcc/ni_600400.jpg">
                                                <img src="https://www.thersa.org/globalassets/images/arc/ffcc/ni_600400.jpg">
                                            </div>
                                        </div>
                                        <div>
                                            <h6 class="font-small font-bold text-muted">Progress</h6>
                                            <div class="bg-light bordered padding-hf font-small margin-bottom-hf">
                                                <div class="margin-bottom-hf font-bold">Judul progress</div>
                                                <div>
                                                    <p>Deskripsi progress it has an easy to override visual style, and is appropriately subdued.</p>
                                                </div>
                                                <div class="flex-container">
                                                    <div class="text-primary margin-right-hf">Proses</div>
                                                    <div class="text-muted">- <time datetime="2017-02-14">January 17, 2021</time></div>
                                                </div>
                                            </div>
                                            <div class="bg-light bordered padding-hf font-small margin-bottom-hf">
                                                <div class="margin-bottom-hf font-bold">Judul progress</div>
                                                <div>
                                                    <p>Deskripsi progress it has an easy to override visual style, and is appropriately subdued.</p>
                                                </div>
                                                <div class="flex-container">
                                                    <div class="text-primary margin-right-hf">Tindak lanjut</div>
                                                    <div class="text-muted">- <time datetime="2017-02-14">January 17, 2021</time></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <button id="tryMe" class="btn-panel button" type="button"><i class="fas fa-chevron-right"></i></button>
                    </div>`;

                return html;
            };

            var loadData = function(url) {
                return new Promise(function(resolve, reject) {
                    $.ajax({
                        url: url,
                        method: "get",
                    })
                        .done(function(data) {
                            resolve(data);
                        })
                        .fail(function(err) {
                            reject(err);
                        });
                });
            };

            // if hash presence
            var hashId = parseInt(segments.pop());

            if(typeof hashId === 'number' && isNaN(hashId) !== true){

                $(".loader").addClass("active");

                let dataPlace = loadPlace(hashId);

                dataPlace
                    .then((place) => {
                        $("#modalSearch").foundation("close");
                    })
                    .catch((error) => {
                        console.info(error);
                        $("#modalSearch").foundation("close");
                    });
            }
        }
    )
    .catch((err) => {
        console.error(err);
    });

// Hotkeys
hotkeys("ctrl+/", function(event, handler) {
    // Prevent the default refresh event under WINDOWS system
    event.preventDefault();
    //alert('you pressed search')
    $("#modalSearch").foundation("open");
});
